export default {

  isEnabled: state => flag => {
    return state[flag].isEnabled();
  }
};
